<button class="confirm-button" (click)="pay()">Confirmar Orden</button>